import { ReactNode } from 'react'

import styles from './plain-radio-button.module.scss'

export type LevelShiftProps = {
  children: ReactNode
}

const LevelShift = ({ children }: LevelShiftProps) => {
  return <div className={styles.level1}>{children}</div>
}

export default LevelShift
